import React from 'react';
import { useAuth } from '../context/AuthContext';
import { PRODUCT_NAME, institutionOfUser } from '../config/brand';

/** The shell's brand: the signed-in user's institution, else the product. */
export function useBrand() {
  const { user } = useAuth() || {};
  const institution = institutionOfUser(user);
  return { institution, title: institution?.name || PRODUCT_NAME, product: PRODUCT_NAME };
}

export function BrandIcon({ className = 'w-6 h-6' }) {
  const { institution, title } = useBrand();
  if (institution?.logoUrl) return <img src={institution.logoUrl} alt={institution.name} className={`${className} object-contain`} />;
  return (
    // The console's glyph (apps/console BrandLogo): the same indigo→violet tile in both apps.
    <span
      className={`${className} flex items-center justify-center rounded-lg text-white text-[11px] font-bold`}
      style={{ background: 'linear-gradient(135deg,#4338ca,#6d28d9)' }}
      aria-label={title}
    >
      {title.trim().charAt(0).toUpperCase() || 'U'}
    </span>
  );
}
